import React, { useEffect, useState, useRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { DateObject } from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import { api } from '../services';
import { useNavigate } from 'react-router-dom';
import moment from 'moment-jalaali';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';

const baseUrl = process.env.REACT_APP_API_URL;

// آیکون‌های سفارشی برای دکمه‌های ناوبری
const NextArrow = ({ onClick }) => (
  <div
    className="position-absolute top-50 translate-middle-y"
    style={{
      width: '40px',
      height: '40px',
      backgroundColor: '#fff',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
      cursor: 'pointer',
      zIndex: 1000,
      right: '-50px', // دکمه برای اسکرول به چپ (آیتم‌های قبلی)
    }}
    onClick={onClick}
  >
    <FontAwesomeIcon icon={faChevronRight} style={{ fontSize: '20px', color: '#333' }} />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div
    className="position-absolute top-50 translate-middle-y"
    style={{
      width: '40px',
      height: '40px',
      backgroundColor: '#fff',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
      cursor: 'pointer',
      zIndex: 1000,
      left: '-10px', // دکمه برای اسکرول به راست (آیتم‌های بعدی)
    }}
    onClick={onClick}
  >
    <FontAwesomeIcon icon={faChevronLeft} style={{ fontSize: '20px', color: '#333' }} />
  </div>
);

const DoctorAppointmentModal = ({ show, handleClose, doctor }) => {
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [doctorService, setDoctorService] = useState('');
  const [serviceDoctorHoure, setServiceDoctorHoure] = useState('');
  const [date_n, setDate_n] = useState('');
  const [timeNum, setTimeNum] = useState('');
  const [num, setNum] = useState('');
  const [dates, setDates] = useState([]);
  const [fixedDates, setFixedDates] = useState({
    today: '',
    tomorrow: '',
    dayAfterTomorrow: '',
  });
  const [noAppointmentMessage, setNoAppointmentMessage] = useState('');

  // Ref برای دسترسی به اسلایدر
  const sliderRef = useRef(null);

  const getDoctorService = async () => {
    try {
      const response = await api.get(
        `Home/GetServiceDoctor?OID=1&doctorId=${doctor.DoctorID}`,
      );
      let data = response.data;
      if (typeof data === 'string') {
        data = JSON.parse(data);
      }

      const filtered = data.filter((item) => item.OnlineTurning === 1);
      if (filtered.length === 1) {
        setDoctorService(filtered[0]);
        return filtered[0];
      } else if (filtered.length > 1) {
        console.log(`There are ${filtered.length} items with OnlineTurning equal to 1`);
      } else {
        console.log('No items with OnlineTurning equal to 1 found');
      }
      return null;
    } catch (error) {
      console.error('Error fetching and filtering data:', error);
      return null;
    }
  };

  const getAvailableDates = async (serviceId) => {
    try {
      const response = await api.get(
        `Home/GetDays?OID=1&ServiceDoctorID=${serviceId}`,
      );
      let data = response.data;
      if (typeof data === 'string') {
        data = JSON.parse(data);
      }

      const formattedDates = data.map((item) => {
        const fullDate = new DateObject({
          calendar: persian,
          locale: persian_fa,
          date: moment(item.dt, 'M/D/YYYY').toDate(),
        });
        const dayName = fullDate.format('dddd');
        const formattedDate = fullDate.format('D MMMM YYYY');
        const comparisonDate = moment(item.dt, 'M/D/YYYY').format('YYYY/MM/DD');

        return {
          dayName,
          formattedDate,
          fullDate,
          comparisonDate,
          adamhozor: item.adamhozor,
          nobatno: item.nobatno, // اضافه کردن تعداد نوبت باقی مانده
          holiday: item.holiday, // اضافه کردن وضعیت تعطیلی
        };
      });

      // معکوس کردن لیست تاریخ‌ها برای نمایش جدیدترین در سمت راست
      setDates(formattedDates);
    } catch (error) {
      console.error('Error fetching available dates:', error);
    }
  };

  const GetServiceDoctorHoure = async (date) => {
    if (!date || !doctorService?.ID) return;
    let formattedDate = moment(date.toDate()).format('jYYYY/jM/jD');
    setDate_n(formattedDate);
    setNoAppointmentMessage(''); // Reset message on new date selection

    try {
      const response = await api.get(
        `Home/GetServiceDoctorHoure?oid=1&ServiceDoctorID=${doctorService.ID}&datetime=${formattedDate}`,
      );
      let data = response.data;
      if (typeof data === 'string') {
        data = JSON.parse(data);
      }
      if (!data || data.length === 0) {
        setNoAppointmentMessage('در این روز نوبتی یافت نشد');
        setServiceDoctorHoure([]);
        return;
      }
      data.sort((a, b) => a.NobatTime.localeCompare(b.NobatTime));
      setServiceDoctorHoure(data);
    } catch (error) {
      console.error('Error fetching service doctor hours:', error);
      setNoAppointmentMessage('در این روز نوبتی یافت نشد');
      setServiceDoctorHoure([]);
    }
  };

  useEffect(() => {
    // ریست کردن stateهای نوبت و زمان و پیام
    setDates([]);
    setServiceDoctorHoure([]);
    setSelectedDate(null);
    setSelectedTime(null);
    setNoAppointmentMessage('');

    // محاسبه تاریخ‌های امروز، فردا و پس‌فردا
    const today = moment().format('YYYY/MM/DD');
    const tomorrow = moment().add(1, 'days').format('YYYY/MM/DD');
    const dayAfterTomorrow = moment().add(2, 'days').format('YYYY/MM/DD');

    setFixedDates({
      today,
      tomorrow,
      dayAfterTomorrow,
    });

    const fetchData = async () => {
      const service = await getDoctorService();
      if (service) {
        await getAvailableDates(service.ID);
        // ایجاد تاریخ امروز به فرمت مورد نیاز
        const todayDate = new DateObject({
          calendar: persian,
          locale: persian_fa,
          date: moment().toDate(),
        });
        // انتخاب خودکار تاریخ امروز
        setSelectedDate(todayDate);
        // دریافت نوبت‌های امروز
        GetServiceDoctorHoure(todayDate);
      }
    };
    fetchData();
  }, [doctor]);

  // اسکرول خودکار به راست‌ترین آیتم هنگام لود
  useEffect(() => {
    if (sliderRef.current && dates.length > 0) {
      sliderRef.current.scrollLeft = sliderRef.current.scrollWidth;
    }
  }, [dates]);

  // توابع برای اسکرول دستی
  const handleNext = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: 128, behavior: 'smooth' }); // اسکرول به راست
    }
  };

  const handlePrev = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -128, behavior: 'smooth' }); // اسکرول به چپ
    }
  };

  const getDateLabel = (comparisonDate) => {
    if (comparisonDate === fixedDates.today) return 'امروز';
    if (comparisonDate === fixedDates.tomorrow) return 'فردا';
    if (comparisonDate === fixedDates.dayAfterTomorrow) return 'پس‌فردا';
    return '';
  };

  const handleDateSelect = (date) => {
    setSelectedDate(date);
    setSelectedTime(null);
    GetServiceDoctorHoure(date);
  };

  const HandelSubmit = (hor, time) => {
    const normalizedTime = normalizeTimeToHHMMSS(hor);
    setTimeNum(normalizedTime);
    setNum(time);
    setSelectedTime(normalizedTime);
    localStorage.setItem('time', normalizedTime);
    localStorage.setItem('num', time);
    localStorage.setItem('doctor_id', doctor.DoctorID);
    localStorage.setItem('doctor_name', doctor.Lname);
    localStorage.setItem('doctor_famil', doctor.Fname);
    localStorage.setItem('date_n', date_n);
    localStorage.setItem('Price', doctorService?.Price || '0');
    localStorage.setItem('payment_time', moment().format('jYYYY/jMM/jDD HH:mm'));
    localStorage.setItem('ServiceCategoryID', doctorService?.ServiceCategoryID || '1');
    localStorage.setItem('ServiceDoctorID', doctorService?.ID || '');
    console.log('Appointment selected:', {
      time: normalizedTime,
      num: time,
      doctorId: doctor.DoctorID,
      date: date_n,
      price: doctorService?.Price,
      serviceCategoryId: doctorService?.ServiceCategoryID,
      serviceDoctorId: doctorService?.ID
    });
  };

  const phonenumber = localStorage.getItem('phoneNumber');
  const key = localStorage.getItem('key');

  const handelSubmitOne = () => {
    localStorage.setItem('Price', doctorService?.Price || '0');
    localStorage.setItem('Graduate', doctor.Graduate);
    localStorage.setItem('ServiceDoctorID', doctorService.ID);
    navigate('/login');
  };

  const handelSubmitTwo = async () => {
    localStorage.setItem('Price', doctorService?.Price || '0');
    localStorage.setItem('Graduate', doctor.Graduate);
    localStorage.setItem('ServiceDoctorID', doctorService.ID);

    if (!key) {
      navigate('/login');
    } else {
      try {
        let patientID = localStorage.getItem('patientID');
        if (!patientID) {
          const profileRes = await api.get(`Home/GetProfileInfo?SesID=${key}&OID=1`);
          let profileData = profileRes.data;
          if (typeof profileData === 'string') {
            try { profileData = JSON.parse(profileData); } catch (e) {}
          }
          patientID = profileData?.[0]?.PatientID || '';
          if (patientID) localStorage.setItem('patientID', patientID);
        }

        const gregorian = moment(date_n, 'jYYYY/jM/jD').format('YYYY-MM-DD').split('-');
        const resultTime = `${gregorian[1]}/${gregorian[2]}/${gregorian[0]}`; // MM/DD/YYYY
        const timeValue = normalizeTimeToHHMMSS(localStorage.getItem('time') || timeNum);
        const nobatNumber = localStorage.getItem('num') || num;
        const serviceDoctorId = doctorService?.ID || localStorage.getItem('ServiceDoctorID');

        const response = await api.get(
          `Home/CheckExistingTurn?SesID=${key}&OID=1&PatientID=${patientID}&ServiceDoctorID=${serviceDoctorId}&NobatNumber=${nobatNumber}&timadate=${timeValue}&Date=${resultTime}`
        );
        let data = response.data;
        if (typeof data === 'string') {
          try { data = JSON.parse(data); } catch (e) {}
        }
        const errorMessageValue = (data && typeof data === 'object') ? (data.ErrorMessage ?? data.errormessage ?? data.errorMessage) : undefined;
        const isAllowed = errorMessageValue !== undefined ? `${errorMessageValue}` === '0' : `${data}` === '0';

        if (isAllowed) {
          navigate('/payment');
        } else {
          navigate('/', { state: { turnExists: true } });
        }
      } catch (error) {
        console.error('Error in CheckExistingTurn:', error);
        navigate('/', { state: { turnExists: true } });
      }
    }
  };

  const normalizeTimeToHHMMSS = (time) => {
    if (!time) return '';
    const parts = String(time).split(':');
    const hours = (parts[0] || '00').padStart(2, '0');
    const minutes = (parts[1] || '00').padStart(2, '0');
    const seconds = (parts[2] || '00').padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };

  const formatTime = (time) => {
    const parts = String(time).split(':');
    const hours = (parts[0] || '00').padStart(2, '0');
    const minutes = (parts[1] || '00').padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  const barinUrl = process.env.REACT_APP_BARIN_URL;
  const isReserveButtonDisabled = !selectedDate || !selectedTime;

  return (
    <Modal
      style={{
        width: '100%',
        height: '100%',
        overflow: 'hidden',
      }}
      tabIndex="-1"
      show={show}
      onHide={handleClose}
      centered
      dialogClassName="modal-max-90 modal-responsive"
    >
      <Modal.Body className="pt-10 pb-4" style={{ maxHeight: '90vh', overflowY: 'auto' }}>
        <div className="row">
          <div className="col-12 col-md-3 d-flex flex-column align-items-center mb-3 mb-md-0">
            <div
              className="mb-3"
              style={{
                width: '100px',
                height: '100px',
                overflow: 'hidden',
                borderRadius: '50%',
                border: '2px solid #ddd',
              }}
            >
              <img
                src={`${baseUrl}Home/ShowImg?Filename=${doctor.ImageDoctor}`}
                alt="Doctor Avatar"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  objectPosition: 'center',
                }}
              />
            </div>
            <h5 className="text-center">{doctor.Fname + ' ' + doctor.Lname}</h5>
          </div>
          <div className="col-12 col-md-9 d-flex flex-column" style={{ paddingLeft: "15px", paddingRight: "15px" }}>
            <div className="w-100 mb-3 position-relative" style={{ direction: 'rtl' }}>
              {dates.length > 0 ? (
                <div style={{ position: 'relative' }}>
                  <PrevArrow onClick={handlePrev} />
                  <div
                    ref={sliderRef}
                    style={{
                      display: 'flex',
                      overflowX: 'auto',
                      scrollSnapType: 'x mandatory',
                      scrollbarWidth: 'none',
                      msOverflowStyle: 'none',
                      direction: 'rtl',
                      padding: '10px 0',
                    }}
                    className="hide-scrollbar"
                  >
                    {dates.map((date, index) => (
                      <div
                        key={index}
                        style={{
                          flex: '0 0 auto',
                          marginLeft: '8px',
                          scrollSnapAlign: 'start',
                        }}
                      >
                        <div
                          className={`border rounded p-3 text-center ${
                            selectedDate &&
                            selectedDate.format('jYYYY/jMM/jDD') === date.fullDate.format('jYYYY/jMM/jDD')
                              ? 'border-primary'
                              : ''
                          }`}
                          style={{
                            width: '120px',
                            height: '120px',
                            backgroundColor:
                              date.adamhozor === 1 ||
                              date.nobatno === 0 ||
                              date.comparisonDate === fixedDates.today ||
                              date.holiday === 1
                                ? '#e9ecef'
                                : '#ffffff',
                            cursor:
                              date.adamhozor === 1 ||
                              date.nobatno === 0 ||
                              date.comparisonDate === fixedDates.today ||
                              date.holiday === 1
                                ? 'not-allowed'
                                : 'pointer',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            opacity:
                              date.adamhozor === 1 ||
                              date.nobatno === 0 ||
                              date.comparisonDate === fixedDates.today ||
                              date.holiday === 1
                                ? '0.6'
                                : '1',
                            position: 'relative',
                          }}
                          onClick={() => {
                            if (date.comparisonDate === fixedDates.today) {
                              setNoAppointmentMessage('برای روز جاری نمیتوانید نوبت ثبت کنید');
                              return;
                            }
                            if (date.holiday === 1) {
                              setNoAppointmentMessage('این روز تعطیل است و امکان رزرو نوبت وجود ندارد.');
                              return;
                            }
                            if (date.adamhozor !== 1 && date.nobatno > 0) {
                              setNoAppointmentMessage('');
                              handleDateSelect(date.fullDate);
                            }
                          }}
                          title={
                            date.comparisonDate === fixedDates.today
                              ? 'برای روز جاری نمیتوانید نوبت ثبت کنید'
                              : date.holiday === 1
                              ? 'این روز تعطیل است و امکان رزرو نوبت وجود ندارد.'
                              : date.adamhozor === 1
                              ? 'پزشک در این روز حضور ندارد'
                              : date.nobatno === 0
                              ? 'نوبت‌ها تکمیل نوبت ها '
                              : `${date.nobatno} نوبت باقی مانده`
                          }
                        >
                          <div className="fw-bold mb-2" style={{ fontSize: '14px' }}>
                            {date.dayName}
                          </div>
                          <div style={{ fontSize: '12px', direction: 'rtl' }}>{date.formattedDate}</div>
                          <div
                            className="text-center mt-1"
                            style={{ color: '#6c757d', fontSize: '12px' }}
                          >
                            {getDateLabel(date.comparisonDate)}
                          </div>
                          {date.comparisonDate === fixedDates.today ? (
                            <div
                              style={{
                                position: 'absolute',
                                bottom: '5px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                fontSize: '10px',
                                color: 'red',
                                width: '100%',
                              }}
                            >
                              غیرقابل رزرو برای امروز
                            </div>
                          ) : date.holiday === 1 ? (
                            <div
                              style={{
                                position: 'absolute',
                                bottom: '5px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                fontSize: '10px',
                                color: 'red',
                                width: '100%',
                              }}
                            >
                             ....
                            </div>
                          ) : date.adamhozor === 1 ? (
                            <div
                              style={{
                                position: 'absolute',
                                bottom: '5px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                fontSize: '10px',
                                color: 'red',
                                width: '100%',
                              }}
                            >
                              عدم حضور پزشک
                            </div>
                          ) : date.nobatno === 0 ? (
                            <div
                              style={{
                                position: 'absolute',
                                bottom: '5px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                fontSize: '10px',
                                backgroundColor: '#007bff',
                                color: '#fff',
                                padding: '2px 6px',
                                borderRadius: '4px',
                                width: '100%',
                              }}
                            >
                            تکمیل نوبت ها 
                            </div>
                          ) : (
                            <div
                              style={{
                                position: 'absolute',
                                bottom: '5px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                fontSize: '10px',
                                color: 'green',
                                width: '100%',
                              }}
                            >
                              {date.nobatno} نوبت باقی مانده
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                  <NextArrow onClick={handleNext} />
                </div>
              ) : (
                <div className="text-center">
                  <p style={{ color: 'red', fontSize: '16px' }}>در حال بارگذاری...</p>
                </div>
              )}
              <style>
                {`
                  .hide-scrollbar::-webkit-scrollbar {
                    display: none;
                  }
                  .modal-responsive {
                    max-width: 95% !important;
                    margin: 10px auto;
                  }
                  @media (max-width: 768px) {
                    .modal-responsive {
                      max-width: 100% !important;
                      margin: 0;
                    }
                    .btn-nobat {
                      flex: 0 0 calc(33.333% - 8px) !important;
                      min-width: unset !important;
                    }
                  }
                  .btn-nobat-container {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 8px;
                    margin-bottom: 1rem;
                    max-height: calc(40vh - 100px);
                    overflow-y: auto;
                    padding: 10px;
                  }
                  .btn-nobat {
                    flex: 0 0 calc(25% - 8px);
                    text-align: center;
                    border: 2px solid #007bff !important; /* رنگ دلخواه */
                    box-shadow: 0 2px 8px rgba(0,0,0,0.05); /* اختیاری برای زیبایی */
                  }
                  /* Long tracking code/authority text should wrap and be LTR on mobile */
                  .ltr-break {
                    direction: ltr;
                    unicode-bidi: bidi-override;
                    word-break: break-all;
                    overflow-wrap: anywhere;
                    display: inline-block;
                    max-width: 100%;
                    vertical-align: bottom;
                  }
                `}
              </style>
            </div>
            {serviceDoctorHoure && serviceDoctorHoure.length > 0 && (
              <div className="btn-nobat-container">
                {serviceDoctorHoure.map((hour, index) => (
                  <Button
                    key={index}
                    className="btn-nobat"
                    variant={
                      hour.isempty === 0
                        ? 'secondary'
                        : selectedTime === hour.NobatTime
                        ? 'primary'
                        : 'outline-primary'
                    }
                    onClick={() => HandelSubmit(hour.NobatTime, hour.NobatNumber)}
                    style={{
                      fontSize: '14px',
                      padding: '10px',
                      borderRadius: '8px',
                      border: selectedTime === hour.NobatTime ? '2px solid #007bff' : '2px solid #ccc',
                    }}
                    disabled={hour.isempty === 0}
                  >
                    {formatTime(hour.NobatTime)}
                  </Button>
                ))}
              </div>
            )}
            {noAppointmentMessage && (
              <div className="text-center mb-3">
                <p style={{ color: 'red', fontSize: '16px' }}>{noAppointmentMessage}</p>
              </div>
            )}
            <div className="d-flex justify-content-center gap-2 mt-3">
              {key ? (
                <Button
                  variant="primary"
                  className="px-4 py-2"
                  onClick={handelSubmitTwo}
                  disabled={isReserveButtonDisabled}
                >
                  رزرو نوبت
                </Button>
              ) : (
                <Button
                  variant="primary"
                  className="px-4 py-2"
                  onClick={handelSubmitOne}
                  disabled={isReserveButtonDisabled}
                >
                  رزرو نوبت
                </Button>
              )}
              <Button className="px-4 py-2" variant="secondary" onClick={handleClose}>
                بستن
              </Button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DoctorAppointmentModal;